import { render, staticRenderFns } from "./Einrahmen.vue?vue&type=template&id=d532ebd0&scoped=true&"
import script from "./Einrahmen.vue?vue&type=script&lang=js&"
export * from "./Einrahmen.vue?vue&type=script&lang=js&"
import style0 from "./Einrahmen.vue?vue&type=style&index=0&id=d532ebd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d532ebd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VImg,VSheet})
